<template>
  <div class="active-requests-sidebar">
    <!-- Heading -->
    <div class="sidebar-heading">
      {{ $t('activeRequestsByCountry') }}
    </div>
    <!-- Country List with Active Requests -->
    <ul class="list-group list-group-flush">
      <li
        v-for="requestCountry in activeRequestsCountByCountry"
        :key="requestCountry"
        class="list-group-item d-flex justify-content-between align-items-center"
        @click="selectCountry(requestCountry.country)"
      >
        <span class="badge badge-primary badge-pill">{{ $t(`countries.${requestCountry.country}`) }}</span>
        {{ requestCountry.numberOfRequests }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // Expecting an object where key is country name and value is count of active requests
    activeRequestsCountByCountry: {
      type: Array,
      required: true
    }
  },
  methods:{
    selectCountry(country) {
      // Emit the event with the country code
      this.$emit('country-selected', country);
    }
  }
}
</script>

<style scoped>
.active-requests-sidebar {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  margin-top: 1rem;
  height: calc(100vh - 2rem);
  overflow-y: auto;
}

.sidebar-heading {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
  padding-bottom: .5rem;
  border-bottom: 1px solid #eaeaea;
}

.list-group-item {
  cursor: pointer;
  transition: background-color .3s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.badge {
  background-color: #007bff;
  font-size: 0.9rem;
}

/* Additional media queries and styles can be added to improve responsiveness */
</style>
